import { Widget } from '../Griglia'
import { t } from '../../i18n/lingua'

/**
 * I widget «generali»: non leggono dati, servono a **comporre** un sinottico.
 * Un'**immagine** (la planimetria del reparto, lo schema della rete, un logo)
 * e un **testo** (un titolo, una didascalia, una legenda). Senza cornice,
 * sul monitor, sono lo sfondo e le scritte su cui si appoggiano gli altri
 * widget: la matrice libera li lascia sovrapporre.
 */

type Props = { options: Record<string, unknown>; sinottico: boolean }

export function Immagine({ options }: Props) {
  const src = String(options.src ?? '')
  const fit = String(options.fit ?? 'contain')
  const cornice = options.cornice == null ? false : options.cornice === true || options.cornice === 'true'
  const didascalia = String(options.caption ?? '')
  const corpo = src ? (
    <figure className="wimg">
      <img src={src} alt={didascalia || t('Immagine')} className={`wimg__img wimg__img--${fit}`} draggable={false} />
      {didascalia && <figcaption className="wimg__didascalia">{didascalia}</figcaption>}
    </figure>
  ) : (
    <p className="muted" style={{ margin: 0 }}>{t('Scegli un’immagine in «Personalizza»: un file dal computer o un indirizzo.')}</p>
  )
  return <Widget titolo={didascalia || t('Immagine')} nudo={!!src && !cornice}>{corpo}</Widget>
}

export function Testo({ options }: Props) {
  const testo = String(options.text ?? '')
  const misura = String(options.size ?? 'm')
  const allinea = String(options.align ?? 'left')
  const cornice = options.cornice === true || options.cornice === 'true'
  const corpo = (
    <div className={`wtesto wtesto--${misura} wtesto--${allinea}`}>
      {testo || <span className="muted">{t('Scrivi il testo in «Personalizza».')}</span>}
    </div>
  )
  return <Widget titolo={t('Testo')} nudo={!cornice}>{corpo}</Widget>
}
